import React, { useEffect, useState } from 'react'
import RegisterViewV2 from './RegisterViewV2';
import PublicPage from '../PublicPage';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import { useTranslation } from 'react-i18next';
import CustomAlert from '../../components/CustomAlert';
import CustomLoading from '../../components/CustomLoading';
import { useHistory } from 'react-router-dom';

export default function RegisterControllerV2(props) {
    const { t } = useTranslation();
    const [authOtp, setauthOtp] = useState(null);
    const [obfuscatedValue, setobfuscatedValue] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const history = useHistory();

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    const handleRegister = async (values) => {
        onShowLoading(true);
        if (values && values.email)
            try {
                var result = await wsclients.contacts.contactsOtp(values.email);
                console.log("contactsOtp result:", result);
                if (result.code == 'OK') {
                    setauthOtp(result.data.auth_otp)
                    setobfuscatedValue(result.data.obfuscated_value)
                    setOpenModal(true)
                } else if (result.code == 'UNCLASSIFIED_ERROR') {
                    onShowMessage({ show: true, content: result.data.message });
                } else if (result.code == 'TOO_MANY_REQUESTS') {
                    onShowMessage({ show: true, content: t('Too Many Requests') });
                } else {
                    onShowMessage(true, t('FORGOT_PASSWORD_FAIL'));
                }
            } catch (error) {
                console.log("on contacts Otp exception:", error);
                onShowMessage({ show: true, content: t('EXCEPTION_PROCESS') });
            }
        onShowLoading(false);
    }

    const handleValidate= async (otp) => {
        console.log("on contacts Otp exception:", otp);
        onShowLoading(true);
        if (otp)
            try {
                var result = await wsclients.contacts.validateOtp(authOtp, otp);
                console.log("validateOtp result:", result);
                if (result.code == 'OK') {
                    var contactId = result.data.contact.id
                    var access_token = result.data.access_token
                    history.push(paths.register_identify, { contactId, access_token });
                } else if (result.code == 'UNCLASSIFIED_ERROR') {
                    onShowMessage({ show: true, content: t('Invalid OTP.') });
                } else if (result.code == 'TOO_MANY_REQUESTS') {
                    onShowMessage({ show: true, content: t('Too Many Requests') });
                } else {
                    onShowMessage(true, t('Error'));
                }
            } catch (error) {
                console.log("on contacts Otp exception:", error);
                onShowMessage({ show: true, content: t('EXCEPTION_PROCESS') });
            }
        onShowLoading(false);
    }

    const handleCloseModal = () => setOpenModal(false);

    const onCancel = () => {
        history.push(paths.login);
    }

    return (
        <>
            <PublicPage
                rightComponent={
                    <RegisterViewV2
                        openModal={openModal}
                        obfuscatedValue={obfuscatedValue}
                        handleRegister={handleRegister}
                        handleCloseModal={handleCloseModal}
                        handleValidate={handleValidate}
                        onCancel={onCancel}
                    />
                }
            />
            {message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                onClose={() => onShowMessage({})}
            />}
            {showLoading && <CustomLoading open={showLoading} />}
        </>
    );
}